import "./CertificateGroupingGWPConcrete.scss";
import CertificateGroupingListGWPConcrete from "../../features/CertificateGroupingListGWPConcrete/CertificateGroupingListGWPConcrete";

const CertificateGroupingGWPConcrete = () => {
  return (
    <div className="analytics-page">
      <CertificateGroupingListGWPConcrete />
    </div>
  );
};

export default CertificateGroupingGWPConcrete;
